import { render, staticRenderFns } from "./HsabExpenseGlobalModals.vue?vue&type=template&id=02850d20&scoped=true"
import script from "./HsabExpenseGlobalModals.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseGlobalModals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02850d20",
  null
  
)

export default component.exports